import * as React from 'react'
import { Prompt } from 'react-router'

import { ProjectCaseTypePartial } from './projectQueries'
import ThumbImage from './ThumbImage'
import ProjectCase from './ProjectCaseContainer'
import {
  TabWorkArea,
  CaseListRow,
  ThumbView,
  ThumbButtonFullWidth,
  ImageTools,
  Field,
  FieldHeader,
  FieldValue
} from './Styles'
import { Dispatch } from 'redux'
import { compose } from 'react-apollo'
import { connect } from 'react-redux'
import { Store } from '../../reducers'
import { withRouter } from 'react-router-dom'
import { History, Location } from 'history'
import { Action } from '../../actions/types'
import { setTabulationLock } from '../../actions/tabulation'
import { changeCase } from '../../actions/project'

const fieldNames = {
  name: 'Case',
  description: 'Description'
}

type InputProps = {
  cases: ProjectCaseTypePartial[]
  setTabLock: (lock: boolean) => Action
  selectCase: (caseId: string) => Action
  tabulationLocked: boolean
  location: Location
  history: History
}

type State = {
  locked: boolean[]
}

const prompt = location => ({ pathname }) =>
  'You have unchanged edits that will not be saved if you leave the page'

export class CaseList extends React.Component<InputProps, State> {
  constructor(props: InputProps) {
    super(props)
    this.state = { locked: [] }
  }

  componentWillMount() {
    this.setState({ locked: this.props.cases.map(projCase => false) })
  }

  renderFieldHeader(name: string) {
    return <FieldHeader>{fieldNames[name]}</FieldHeader>
  }

  renderTextField(name: string, value: string) {
    return (
      <Field>
        {this.renderFieldHeader(name)}
        <FieldValue>{value}</FieldValue>
      </Field>
    )
  }

  _lockTabs(indx: number, lock: boolean) {
    const { setTabLock } = this.props
    const locked = this.state.locked
    locked[indx] = lock
    this.setState({ locked }, () => setTabLock(locked.includes(true)))
  }

  clickImage(projectCase: ProjectCaseTypePartial) {
    this.props.history.push(
      `/project/${projectCase.projectId}/workspace/?caseId=${projectCase.id}`
    )
  }

  render() {
    const { cases, tabulationLocked, location } = this.props
    const { locked } = this.state

    return (
      <TabWorkArea id="tab-work-area">
        {cases.map((projectCase, indx) => {
          const disabled = locked.includes(true) && !locked[indx]
          return (
            <CaseListRow key={indx}>
              <ThumbView>
                <ThumbImage
                  imageUrl={projectCase.thumbnail}
                  onClick={() => this.clickImage(projectCase)}
                />
                <ImageTools>
                  <ThumbButtonFullWidth
                    onClick={() => this.clickImage(projectCase)}
                  >
                    Open case
                  </ThumbButtonFullWidth>
                </ImageTools>
              </ThumbView>
              <ProjectCase
                projectCaseId={projectCase.id}
                disabled={disabled}
                lockTabs={lock => this._lockTabs(indx, lock)}
              />
            </CaseListRow>
          )
        })}
        <Prompt message={prompt(location)} when={tabulationLocked} />
      </TabWorkArea>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  tabulationLocked: state.tabulation.locked
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  setTabLock: lock => dispatch(setTabulationLock(lock)),
  selectCase: (caseId: string) => dispatch(changeCase(caseId))
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CaseList)



// WEBPACK FOOTER //
// ./src/Components/Projects/CaseList.tsx